// extracted by mini-css-extract-plugin
export default {"hidden":"StylistAllowancesExcelTable_hidden__Cu+u2"};